import { Injectable } from "@angular/core";
import { Client } from "../models/client";
import { Language } from "../models/language";

@Injectable()
export class VisualisLanguageService {

  // ==============================================================
  // State properties
  // ==============================================================
  public dataLoaded: boolean;
  public requestedLang: string;
  public currentLang: string;
  public translate: Map<string, string>;
  //CC usare esto para saber el factor de conversion de trs
  public trsConversionFactor : number = 1;

  constructor() {
    this.dataLoaded = false;
    this.requestedLang = "default";
    this.currentLang = "es";
  }

  getLanguageFromClient(client: Client): string {
    // Here we'll parse the config and obtain the language
    let clientOk = false;
    let lang = "es";

    var j:any;
    if ((client != null || client != undefined) && (client.config != null || client.config) != undefined) {
      try {
        j = JSON.parse(client.config);
        clientOk = j.languageConfiguration != null && j.languageConfiguration != undefined;
      } catch (e) {
        console.warn("Error Controlado", e);
      }
    }

    if (clientOk) {
      try
      {
        lang = j.languageConfiguration.language;
        //console.log("Language obtained from client:", lang);
      } catch
      {
        lang = "es";
      }
    } else {
      //console.log("Language could not be obtained from client : ", client);
    }

    return lang;
  }


  initLang(lang: Language): void {

    this.currentLang = lang.code;
    this.translate = new Map<string, string>();
    lang.translations.forEach(e => {
      this.translate.set(e.code, e.text);
    });
    this.dataLoaded = true;

    // Setup demo EN map
    // if (this.currentLang === "es") {
    //   this.translate.set("dashboard-timerange_lasthour","Última Hora");
    //   this.translate.set("dashboard-timerange_lasthours_pre","Últimas");
    //   this.translate.set("dashboard-timerange_lasthours_post","Horas");
    //   this.translate.set("dashboard-timerange_lastday","Último Día");
    //   this.translate.set("dashboard-timerange_lastdays_pre","Últimos");
    //   this.translate.set("dashboard-timerange_lastdays_post","Días");
    //   this.translate.set("dashboard-timerange_lastmonth","Último Mes");
    //   this.translate.set("dashboard-timerange_lastmonths_pre","Últimos");
    //   this.translate.set("dashboard-timerange_lastmonths_post","Meses");
    //   this.translate.set("dashboard-aggregates_average","Promedio");
    //   this.translate.set("dashboard-aggregates_minimum","Mínimo");
    //   this.translate.set("dashboard-aggregates_maximum","Máximo");
    //   this.translate.set("dashboard-aggregates_1min","1 Minuto");
    //   this.translate.set("dashboard-aggregates_5min","5 Minutos");
    //   this.translate.set("dashboard-aggregates_10min","10 Minutos");
    //   this.translate.set("dashboard-aggregates_15min","15 Minutos");
    //   this.translate.set("dashboard-aggregates_30min","30 Minutos");
    //   this.translate.set("dashboard-aggregates_1hour", "1 Hora");

    //   this.translate.set("dashboard-administrator", "Administrador");
    //   this.translate.set("dashboard-user", "Usuario");
    //   this.translate.set("dashboard-date", "Fecha");

    //   this.dataLoaded = true;
    // }
  }

  // Main translation routine
  t(code: string): string {
    let r = "_undefined_";

    if (this.dataLoaded) {
      // We have language data downloaded and can ask for translations.
      // Check the current map for the requested code and return the translation
      if (this.translate.has(code)) {
        r = this.translate.get(code);
      }
    }

    return r;
  }
}



// WEBPACK FOOTER //
// ./src/app/visualis/services/language.service.ts